module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/icon/desktop/svg/extract_text_light_24-7a09c3.svg";